"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _blocks = require("@bueno/blocks");

var _core = require("@lingui/core");

var _reactRedux = require("react-redux");

var _actionsUI = require("../../../redux/modules/_BETA/actionsUI");

var _columns = require("../../../utils/columns");

// TODO: Genericify
function mapStateToProps(state) {
  return {
    sortFilter: state.betaActionsUI.sortFilter
  };
}

const mapDispatchToProps = {
  onSortChange: key => (0, _actionsUI.updateSortFunc)(key)
};

const SortSelect = ({
  sortFilter,
  onSortChange
}) => {
  return /*#__PURE__*/_react.default.createElement(_blocks.DropdownMenu, {
    right: true,
    trigger: _core.i18n._({
      id: 'sort_select.v2.title',
      message: `Sort By`
    }),
    onSelect: sortKey => onSortChange(sortKey),
    value: sortFilter,
    options: Object.entries(_columns.actionColumns).map(([key, column]) => ({
      value: key,
      label: column.label(_core.i18n),
      sub: column.label(_core.i18n)
    }))
  });
};

var _default = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(SortSelect);

exports.default = _default;
module.exports = exports.default;